import React, { Fragment, useEffect, useState } from 'react';
import {css, Global, keyframes} from '@emotion/react';
import {BrowserRouter as Router, Switch, Route, Redirect, useHistory, Link} from 'react-router-dom';
import {BtnBorder, BtnSubmit} from '../components/buttons';
import {useToast} from '../toast';

import auth from '../auth';
import validate from '../validate';

import LogoImage from 'url:../images/logo@2x.png';
import {Form, FormControl, FormError} from '../components/form';
import {Helmet} from 'react-helmet';
import config from '../config';
const {siteName} = config;

export default () => {
  const history = useHistory();
  const [student_number, setStudentNumber] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [first_submit, setFirstSubmit] = useState(true);
  const toast = useToast();

  useEffect(() => {
    const data = {student_number, password};
    if ( ! first_submit ) {
      const errors = validate.login(data);
      setErrors(errors);
    }
  }, [student_number, password]);

  const onSubmit = ev => {
    ev.preventDefault();
    doLogin();
  };
  const doLogin = () => {
    const data = {student_number, password};
    const errors = validate.login(data);
    setFirstSubmit(false);

    if ( Object.keys(errors).length > 0) {
      setErrors(errors);
      return false;
    }
    auth.login(student_number, password)
      .then(() => {
        toast.info('ログインしました');
        history.push('/')
      })
      .catch(error => {
        // setErrors(error);
        toast.error('ログインに失敗しました');
      });
  }

  return (
      <div css={css`
        max-width: 328px;
        width: 100%;
        height: 236px;
        padding: 0 20px;
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
      `}>
        <Helmet>
          <title>ログイン | {siteName}</title>
        </Helmet>
        <div css={css`text-align: center; margin: 0 0 30px;`}><img src={LogoImage} css={css`max-width: 100%; width: 247.29px;`}/></div>
        <Form onSubmit={(ev) => onSubmit(ev)}>
            <div css={css`margin: 0 0 10px; width: 100%;`}>
                <input type="text" className={errors.student_number && `hasError`} placeholder="教習生番号" value={student_number} onChange={ev => setStudentNumber(ev.target.value)} onKeyPress={(ev)=> ev.which == 13 && doLogin()}/>
                {errors.student_number && <FormError text={errors.student_number}/>}
            </div>
            <div css={css`margin: 0 0 30px; width: 100%;`}>
                <input type="password" className={errors.password && `hasError`} placeholder="パスワード" value={password} onChange={ev => setPassword(ev.target.value)} onKeyPress={(ev)=> ev.which == 13 && doLogin()}/>
                {errors.password && <FormError text={errors.password}/>}
            </div>
            <BtnBorder name="ログイン" action={()=> doLogin()}/>
            </Form>
    </div>
  );
}
